import { SVGProps } from 'react';

const ArrowLeftFromLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9 18-6-6 6-6m-6 6h14m4 7V5"
    />
  </svg>
);
export default ArrowLeftFromLine;
